var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboards',
          icon: 'ni ni-shop text-primary',
          path: '/dashboard'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Documents',
          icon: 'ni ni-single-copy-04 text-pink'
        }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Circulars', path: '/documents/circulars' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Directives', path: '/documents/directives' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Flight Safety', path: '/documents/flightsafety' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Letters', path: '/documents/letters' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Miscellaneous', path: '/documents/misc' }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Schemes',
          icon: 'ni ni-ungroup text-orange'
        }}},[_c('sidebar-item',{attrs:{"link":{ name: 'All Schemes', path: '/schemes/list' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Mutual Help Welfare', path: '/schemes/mhw' }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Grievances',
          icon: 'ni ni-briefcase-24 text-green',
          path: '/grievances'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Bulletin',
          icon: 'ni ni-tag text-green',
          path: '/bulletin'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Members',
          icon: 'ni ni-circle-08 text-green',
          path: '/members'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'GM Policy',
          icon: 'ni ni-ungroup text-orange',
          path: '/schemes/groupmedical'
        }}})],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }